module.exports = __webpack_public_path__ + "img/success-academy-growth.22b5b254.png";